module.exports = __webpack_public_path__ + "static/media/loader.3b418be6.svg";